import { Modal, Text, Group, Button } from 'components'
import { useTranslation } from 'react-i18next'
import { useMantineTheme, useMediaQuery } from 'hooks'

interface ConfirmRemovalModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  message: string
  isLoading: boolean
}

export const ConfirmRemovalModal = ({
  opened,
  onClose,
  onConfirm,
  message,
  isLoading
}: ConfirmRemovalModalProps) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('arc_confirm_removal_title')}
      fullScreen={isMobile}
      size="md"
      closeOnClickOutside={!isLoading}
      closeOnEscape={!isLoading}
      withCloseButton={!isLoading}
    >
      <Text size="md" mb="lg">
        {message}
      </Text>

      <Group position="right" spacing="sm">
        <Button
          variant="default"
          onClick={onClose}
          disabled={isLoading}
        >
          {t('general_buttons_cancel')}
        </Button>
        <Button
          color="red"
          onClick={onConfirm}
          loading={isLoading}
        >
          {t('general_buttons_confirm')}
        </Button>
      </Group>
    </Modal>
  )
}
